import React from "react";
export default function ContactSection() {
  return (
    <section id="contact" className="parallax-section">
      <div className="container">
        <div className="row">
          <div className="wow fadeInUp col-md-offset-1 col-md-5 col-sm-6" data-wow-delay="0.6s">
            <div className="contact_des">
              <h2>Contact Us</h2>
              <p><strong>Address:</strong> Vidyabharati Rashtriya Khelkud Vibhag </p>  
              <p> <strong> Head Office: </strong> Vidyabharati Rashtriya Khel Karyalaya
                                Saraswati Shiksha Sansthan Chhatishgarh
                                Behind Ayurvedic College, Saraswati Vihar, Rohinipuram, Raipur - 492010</p>
              <p><strong>Email:</strong> vidyabhartikhel@gmail.com</p>
               <p><strong>Phone/FAX:</strong> 0771-4009230</p>
              <p><strong>Phone:</strong> +91 9303088272</p>
              
            </div>
          </div>
          <div className="wow fadeInUp col-md-5 col-sm-6" data-wow-delay="0.9s">
            <div className="contact_detail">
              <div className="section-title">
                <h2>Find Us Here</h2>
              </div>
              <div style={{ width: "100%" }}>
                <iframe
                  width="100%"
                  height="300"
                  frameBorder="0"
                  style={{ border: 0 }}
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d464.8405466008064!2d81.6008401!3d21.2427757!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a28de0b275e98bb%3A0xa9fd8ebd6c5a1e7!2sSaraswati%20Shiksha%20Sansthan!5e0!3m2!1sen!2sin!4v1752667153151!5m2!1sen!2sin"
                  allowFullScreen
                  title="Google Map"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
